// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b0e7f4ba","453":"aee4ca59","666":"4036f77f","849":"6e6d50ce","977":"64256738"}[chunkId] + ".chunk.js";
};